export class Todo {
    constructor(public text: string, public type: string, public isChecked: boolean) {}
}



// WEBPACK FOOTER //
// E:/Git_new/IVMS_PRO/web/src/app/shared/todo/index.ts